import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { checkoutPageGuard } from 'src/app/pages/checkout/checkout-page.guard';

import { featureToggleGuard } from 'ish-core/feature-toggle.module';
import { noServerSideRenderingGuard } from 'ish-core/guards/no-server-side-rendering.guard';

const routes: Routes = [
  {
    path: 'one-page-checkout',
    loadChildren: () =>
      import('./one-page-checkout-summary/one-page-checkout-summary-page.module').then(
        m => m.OnePageCheckoutSummaryPageModule
      ),
    data: {
      feature: 'onePageCheckout',
      headerType: 'checkout',
      meta: {
        title: 'seo.title.checkout',
        robots: 'noindex, nofollow',
      },
    },
    canActivate: [featureToggleGuard, checkoutPageGuard, noServerSideRenderingGuard],
  },
  {
    path: 'one-page-checkout/receipt',
    loadChildren: () =>
      import('./custom-checkout-receipt/custom-checkout-receipt-page.module').then(
        m => m.CustomCheckoutReceiptPageModule
      ),
    data: {
      feature: 'onePageCheckout',
      headerType: 'checkout',
      checkoutStep: 5,
      meta: {
        title: 'seo.title.checkout',
        robots: 'noindex, nofollow',
      },
    },
    canActivate: [featureToggleGuard, noServerSideRenderingGuard],
  },
  {
    path: 'one-page-checkout/submit-order',
    loadChildren: () =>
      import('./custom-checkout-submit-order/custom-checkout-submit-order-page.module').then(
        m => m.CustomCheckoutSubmitOrderPageModule
      ),
    data: {
      feature: 'onePageCheckout',
      headerType: 'checkout',
      meta: {
        title: 'seo.title.checkout',
        robots: 'noindex, nofollow',
      },
    },
    canActivate: [featureToggleGuard, checkoutPageGuard, noServerSideRenderingGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OnePageCheckoutRoutingModule {}
